import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { ProgressService, UserApplications } from '../../+state';

@Injectable()
export class ApplicationListService {
  list$ = this.getList();

  loading$ = this.userApplications.loading$;

  loaded$ = this.userApplications.loaded$;

  constructor(
    private userApplications: UserApplications,
    private progress: ProgressService
  ) {}

  getList() {
    return combineLatest([
      this.userApplications.userApplications$,
      this.progress.entities$
    ]).pipe(
      debounceTime(0),
      map(([applications, progresses]) =>
        applications.map(application => {
          const progress = progresses[application.progress];
          return { ...application, progress };
        })
      )
    );
  }
}
